<template>
  <div class="row">
    <div class="col-12">
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <form @submit.prevent="submitForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="Nom"
                    v-model="userData.name"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse e-mail
                  </label>
                  <input
                    type="email"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. adam127704@gmail.com"
                    v-model="userData.email"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. +001 321 4567"
                    v-model="userData.phone"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25 position-relative">
                  <label class="d-block text-black fw-semibold mb-10">
                    Mot de passe
                  </label>
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="Laisser vide pour ne pas changer"
                    v-model="userData.password"
                  />
                  <i
                    class="ph"
                    :class="showPassword ? 'ph-eye-slash' : 'ph-eye'"
                    @click="showPassword = !showPassword"
                    style="
                      position: absolute;
                      right: 15px;
                      top: 42px;
                      cursor: pointer;
                    "
                  ></i>
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                  >
                    Enregistrer les modifications
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";

export default defineComponent({
  name: "StaffAccountSettings",

  setup: () => {
    const { showToast } = useAppToast();

    const userData = reactive<Record<string, any>>({
      name: "",
      email: "",
      phone: "",
      password: "",
    });
    const showPassword = ref(false);

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/client/showAccount`);
        userData.name = response.data.data.name ?? "";
        userData.email = response.data.data.email ?? "";
        userData.phone = response.data.data.phone ?? "";
      } catch (error) {
        console.error("Error fetching user account:", error);
      }
    });

    async function submitForm() {
      try {
        const formData = new FormData();
        formData.append("name", userData.name);
        formData.append("email", userData.email);
        formData.append("phone", userData.phone);
        if (userData.password) {
          formData.append("password", userData.password);
        }

        const response = await api.post(
          "/api/auth/client/EditStaffProfile",
          formData
        );

        if (response.data.success) {
          showToast("Profil mis à jour avec succès", "success");
          userData.password = "";
        } else {
          showToast(response.data.message || "Une erreur est survenue.", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue lors de l'enregistrement.", "error");
      }
    }

    return {
      userData,
      showPassword,
      submitForm,
    };
  },
});
</script>
